<template>
  <div class="row">
    <layouts-create />
  </div>
</template>

<script>
import LayoutsCreate from './../components/LayoutsCreate'

export default {
  name: 'LayoutsNew',
  components: {
    LayoutsCreate
  }
}
</script>

<style>

</style>
